import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { googleProvider, fbProvider } from "../../firebase-config";
import './Style.css'
import { useDispatch } from 'react-redux';
import { makeLoginExternal, makeLoginFirebase } from '../../core/actions/authActions';
import withIcons from '../../hoc/withIcons';


const LoginPage: React.FunctionComponent<any> = ({ icons }) => {

    const [loginEmail, setLoginEmail] = useState(localStorage.getItem('email') ? localStorage.getItem('email') : "");
    const [loginPassword, setLoginPassword] = useState("");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [showPwd, setShowPwd] = useState<any>({ type: 'password', icon: icons.eyeclose });
    const [rememberdata, setRememberdata] = useState(localStorage.getItem('email') ? true : false);

    const togglePwd = () => {
        if (showPwd.type === 'password') {
            setShowPwd({ type: 'text', icon: icons.eye });
        } else {
            setShowPwd({ type: 'password', icon: icons.eyeclose });
        }
    }

    const login = async (e) => {
        e.preventDefault();
        if (rememberdata) {
            localStorage.setItem('email', loginEmail);
        }
        dispatch(makeLoginFirebase({ loginEmail, loginPassword }));
    };


    const externalLogin = async (provider) => {
        dispatch(makeLoginExternal(provider));
    }


    return (
        <form className='flex flex-col justify-between items-center h-full absolute w-full pt-8 pb-8' onSubmit={login}>

            <div className='fixed left-3 top-3' onClick={() => {
                navigate(-1);
            }}>
                <strong> {icons.back}  </strong>
            </div>

            <div className='w-full max-w-md p-8'>
                <div className='title_lg'>¡Inicia sesión ahora!</div> <br />
                <div className='subtitle-lg'>¿No tienes cuenta todavía? <span><Link to="/auth/registro">¡Registrate!</Link></span></div>
            </div>
            <div className='w-full p-8 max-w-md'>

                <div className='w-full'>
                    <div className="flex items-center border-b border-teal-500 py-2">
                        {icons.mail}
                        <input className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none" type="email" placeholder="Correo electrónico" aria-label="Email"
                            value={loginEmail}
                            onChange={(event) => {
                                setLoginEmail(event.target.value);
                            }} required />
                    </div>
                </div>

                <div className='w-full mt-4'>
                    <div className="flex items-center border-b border-teal-500 py-2">
                        {icons.secure}
                        <input className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none" autoComplete='on' type={showPwd.type} placeholder="Contraseña" aria-label="Password"
                            onChange={(event) => {
                                setLoginPassword(event.target.value);
                            }} required />
                        <button onClick={togglePwd} type='button'>{showPwd.icon}</button>
                    </div>
                </div>

                <div className='mt-4 flex flex-row justify-between items-center'>
                    <div>
                        <label className="inline-flex items-center">
                            <input type="checkbox" className="form-checkbox h-4 w-4" checked={rememberdata} onChange={(e) => { setRememberdata(e.target.checked) }} />
                            <span className="ml-2 textos-mini">Recordarme</span>
                        </label>
                    </div>
                    <span className='textos-mini'><Link to="/auth/recuperar">¿Olvidaste contraseña?</Link></span>
                </div>

            </div>
            <div className='flex flex-col w-full p-8 max-w-md'>
                <button className="primary_btn hover:primary_btn text-white font-bold py-2 px-4 w-full" type='submit'>
                    Iniciar sesión
                </button>
                <div className='mt-4 flex flex-row justify-center items-center'>
                    <span className='mr-4'>o continúa con</span>
                    <div className='circle-icon mr-4' onClick={() => { externalLogin(fbProvider) }}>{icons.facebook}</div>
                    <div className='circle-icon' onClick={() => { externalLogin(googleProvider) }}>{icons.google}</div>
                </div>
            </div>

        </form>

    )
}


export default withIcons(LoginPage);